<template>
	<div>
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			
			<el-form :inline="true">
				<!--:disabled="this.sels.length === 0"--> 
				<el-form-item v-if="Limits.nonwarehoused_refreshGPRS">
					<el-button type="primary" size="small" @click="Getnew">刷新GPRS状态</el-button>
				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入内容" v-model="inputMore" class="input-with-select" size="small">
					    <el-select v-model="selectMore" slot="prepend" placeholder="请选择">
					    	<!--<el-option label="内部ID/任务单号" value="1"></el-option>-->
						    <el-option label="设备ID" value="2"></el-option>
						    <el-option label="Mac地址" value="3"></el-option>
					    </el-select>
				    <el-button slot="append" icon="el-icon-search" @click="Find">查询</el-button>
				  </el-input>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight" @selection-change="selsChange">
			<!--<el-table-column type="selection" width="45"></el-table-column>-->
			<!--<el-table-column label="任务单号" prop="sid" :formatter="dataForm"></el-table-column>-->
			<!--<el-table-column label="SID" prop="sid" width="130"></el-table-column>-->
			<el-table-column label="DID" prop="did" width="200"></el-table-column>
			<el-table-column label="MAC" prop="mac" width="200"></el-table-column>
			<el-table-column label="颜色" prop="color"></el-table-column>
    		<el-table-column label="版本" prop="edition"></el-table-column>
    		<el-table-column label="气弹簧" prop="spring"></el-table-column>
<!--			<el-table-column label="绑定时间" prop="bind_time" :formatter="dateFormat" width="180"></el-table-column>-->
			<el-table-column label="是否已接收GPRS数据" prop="is_get_gprs"></el-table-column>
			<el-table-column label="操作" width="80" v-if="Limits.nonwarehoused_storage">
				<template slot-scope="scope">  
					<el-button v-if="scope.row.is_get_gprs == '是' && scope.row.bind_time && scope.row.mac" size="mini" type="primary" @click="Ruku(scope.$index,scope.row)">入库</el-button>
				    <el-button v-if="scope.row.is_get_gprs == '否' || !scope.row.bind_time || !scope.row.mac" :disabled="true" size="mini" type="danger">入库</el-button>        
				</template>
			</el-table-column>
		</el-table>
		
		<el-col :span="24" class="toolbar downtool">
        	<!--<el-button v-if="Limits.warehoused_index" type="primary" size="small" @click="ShowIn">显示已入库设备</el-button>-->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;"></el-pagination>
		</el-col>
		
		<el-dialog title="已入库设备" :visible.sync="InVisible" :fullscreen="true">
			<el-table :data="List2" border v-loading="listloading2">
			    <el-table-column label="任务单号" prop="sid" :formatter="dataForm"></el-table-column>
				<el-table-column label="SID" prop="sid" width="130"></el-table-column>
				<el-table-column label="DID" prop="did" width="200"></el-table-column>
				<el-table-column label="MAC" prop="mac" width="200"></el-table-column>
				<el-table-column label="颜色" prop="color" width="80"></el-table-column>
	    		<el-table-column label="版本" prop="edition" width="80"></el-table-column>
	    		<el-table-column label="气弹簧" prop="spring" width="90"></el-table-column>
<!--				<el-table-column label="绑定时间" prop="bind_time" :formatter="dateFormat" width="180"></el-table-column>-->
<!--				<el-table-column label="入库时间" prop="storage_date" :formatter="dateFormat" width="180"></el-table-column>-->
<!--  				<el-table-column label="确认入库时间" prop="receipt_date" :formatter="dateFormat"></el-table-column>-->
			</el-table>
  		
  			<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2" :current-page="Curpage2" :total="total2" style="float:right;">
			</el-pagination>
			</el-col>
		</el-dialog>
		
		
	</div>
</template>

<script>
	import {GetStoragelist,GetWarehouslist,GetGprsStatuslist} from '../api/api';
	
	export default {
		data(){
			return{
				token:"",
				maxHeight:600,
				Limits:"",
				inputMore:"",
				selectMore:"",
				List:[],
				listloading:false,
				sels:[],
				Pagesize:20,
				Curpage:1,
				total:1,
				keyword:"",
				InVisible:false,
				listloading2:false,
				List2:[],
				Pagesize2:20,
				Curpage2:1,
				total2:1,
				Form:{
					id:""
				}
			}
		},
		methods:{
			selsChange(sels){
				this.sels = sels;
			},
			Find(){
				if(this.inputMore && this.selectMore){
//					if(this.selectMore == 1){
//						this.keyword = {"AND":{"sid":'~'+this.inputMore}}
//					}else 
					if(this.selectMore == 2){
						this.keyword = {"AND":{"did":'~'+this.inputMore}}
					}else if(this.selectMore == 3){
						this.keyword = {"AND":{"mac":'~'+this.inputMore}}
					}
					this.GetList(GetStoragelist,{page:this.Curpage,token:this.token,q:JSON.stringify([this.keyword]),sort:"-id"})
				}
			},
			Refresh(){
				this.selectMore = ""
				this.inputMore = ""
				this.Curpage = 1
				this.GetList(GetStoragelist,{page:this.Curpage,token:this.token,sort:"-id"})
			},
			Ruku(index,row){
				this.listloading = true
				this.Form = Object.assign({}, row);
				let url = "/nonwarehouseds/"+ this.Form.id +"/storagestatus?token="+ this.token
				this.axios.put(url).then(res => {
					if(res.status == "200"){
						this.$message({
			            	type: 'success',
			            	message: '操作成功!'
			          	});
			          	this.selectMore = ""
						this.inputMore = ""
			          	this.GetList(GetStoragelist,{page:this.Curpage,token:this.token,sort:"-id"})
					}else{
						this.$message.error('对不起，操作失败。')
						this.listloading = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.listloading = false
				})
			},
			Getnew(){
				this.Curpage = 1
				this.GetList(GetGprsStatuslist,{page:this.Curpage,token:this.token,sort:"-id"})
			},
			handleCurrentChange(val){
				this.Curpage = val
				if(this.inputMore){
//					if(this.selectMore == 1){
//						this.keyword = {"AND":{"sid":'~'+this.inputMore}}
//					}else 
					if(this.selectMore == 2){
						this.keyword = {"AND":{"did":'~'+this.inputMore}}
					}else if(this.selectMore == 3){
						this.keyword = {"AND":{"mac":'~'+this.inputMore}}
					}
					this.GetList(GetStoragelist,{page:this.Curpage,token:this.token,q:JSON.stringify([this.keyword]),sort:"-id"})
				}else{
					this.GetList(GetStoragelist,{page:this.Curpage,token:this.token,sort:"-id"})
				}
			},
			handleCurrentChange2(val){
				this.Curpage2 = val
				this.GetList2(GetWarehouslist,{page:this.Curpage2,token:this.token,sort:"-id"})
			},
			dataForm(row,column){			
				var data = row[column.property]
				if (data == undefined) {
				   		return ""
				    } 
				data = data.slice(2,9)
				return data 
			},
			ShowIn(){
				this.InVisible = true
				this.GetList2(GetWarehouslist,{page:this.Curpage2,token:this.token,sort:"-id"})
			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetList(GetStoragelist,{page:this.Curpage,token:this.token,sort:"-id"})
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>
.el-select{
		width: 100px;
	}
</style>


// WEBPACK FOOTER //
// StorageEquipment.vue?461018cc